angular.module('unergie.main')
.config(($stateProvider, $urlRouterProvider, $stateParamsProvider, $locationProvider, Roles) => {
    let submenus

    const checkMenu = (name, $state, $q, AuthService) => {
        const names = _.isArray(name) ? name : [name]
        return Promise.resolve().then(() => {
            if (!submenus) {
                return AuthService.refreshMenus().then((authResult) => {
                    if (authResult) {
                        submenus = AuthService.getSubMenus()
                        return true
                    }
                    return false
                })
            }
            return true
        }).then((logged) => {
            if (logged) {
                if (!_.some(submenus, (s) => names.includes(s))) {
                    console.log(`Page non-autorisée [${names.join(', ')}]`)
                    if (submenus && submenus.length) {
                        // renvoie sur le 1er lien accessible qui n'est pas un WIKI
                        $state.go(_.filter(submenus, (sub) => !sub.includes('wiki'))[0])
                    } else {
                        $state.go('notAuthorized')
                    }
                    return $q.reject()
                }
            }
            return true
        })
    }

    const checkDashboardAccessFromMenu = ($stateParams, $state, $q, AuthService) => {
        const name = `dashboard({id: "${$stateParams.id}"})`
        return checkMenu(name, $state, $q, AuthService)
    }

    const checkWikiAccessFromMenu = ($stateParams, $state, $q, AuthService) => {
        const name = `wiki({title: "${$stateParams.title}"})`
        return checkMenu(name, $state, $q, AuthService)
    }

    const checkAccessFromMenu = (name) => {
        return ['$state', '$q', 'AuthService', ($state, $q, AuthService) => {
            if (AuthService.isLogged()) {
                return checkMenu(name, $state, $q, AuthService)
            }
            return false
        }]
    }

    $stateProvider
    .state('changePwd', {
        url: '/confirmation/:token',
        templateUrl: '/states/changePwdLanding/changePwdLanding.html',
        controller: 'changePwdLandingCtrl',
        params: {
            token: null,
        },
        resolve: {
            identity($stateParams, ApiUser) {
                return ApiUser.getChangePwdEmail({ token: $stateParams.token }).$promise
            },
        },
    }).state('home', {
        url: '',
        abstract: true,
        controller: 'homeCtrl',
        templateUrl: '/states/home/home.html',
        resolve: {
            authDone($location, ApiUser, AuthService) {
                return AuthService.refreshMenus()
                .then(() => {
                    // diabolocom integration
                    const { diabolocomCallId } = $location.search()
                    if (diabolocomCallId && AuthService.isLogged()) {
                        ApiUser.linkDiabolocomCallToBackofficeUser({ diabolocomCallId }).$promise
                        .catch((error) => {
                            console.log(`Error while link diabolocom call to user`, error)
                        })
                    }
                })
            },
            organizations(AuthService, OrganizationService) {
                if (AuthService.isLogged()) {
                    return OrganizationService.getOrgz()
                }
                return []
            },
        },
    }).state('consumptionDashboard', {
        parent: 'home',
        url: '/consumption-dashboard/:idContract',
        templateUrl: '/states/consumptionDashboard/consumptionDashboard.html',
        reloadOnSearch: false,
        controller: 'consumptionDashboardCtrl',
        resolve: {
            access: checkAccessFromMenu('pdls'),
        },
    }).state('consumptionPdlList', {
        parent: 'home',
        url: '/consumption-pdl-list?id',
        templateUrl: '/states/consumptionPdlList/consumptionPdlList.html',
        reloadOnSearch: false,
        controller: 'consumptionPdlListCtrl',
        resolve: {
            access: checkAccessFromMenu('consumptionPdlList'),
        },
    }).state('notAuthorized', {
        parent: 'home',
        url: '/not-authorized',
        template: '<h1 style="text-align: center;"><b>Page non autorisée</b></h1>',
    }).state('csrB2cHome', {
        parent: 'home',
        url: '/csr-b2c-home',
        templateUrl: '/states/csrB2cHome/csrB2cHome.html',
        reloadOnSearch: false,
        controller: 'csrB2cHomeCtrl',
        resolve: {
            access: checkAccessFromMenu('csrB2cHome'),
        },
    }).state('userInfo', {
        parent: 'home',
        url: '/info/:customerId',
        params: {
            contractId: null,
            search: null,
        },
        templateUrl: '/states/userContractInfo/userContractInfo.html',
        reloadOnSearch: false,
        controller: 'userContractInfoCtrl',
        resolve: {
            access: checkAccessFromMenu('clients'),
        },
    }).state('contractInfo', {
        parent: 'home',
        url: '/contract/:search',
        templateUrl: '/states/userContractInfo/userContractInfo.html',
        reloadOnSearch: false,
        controller: 'userContractInfoCtrl',
        resolve: {
            access: checkAccessFromMenu('clients'),
        },
    }).state('contractConsumptionOverview', {
        parent: 'home',
        url: '/contract-consumption-overview/:idContract',
        templateUrl: '/states/contractConsumptionOverview/contractConsumptionOverview.html',
        reloadOnSearch: false,
        controller: 'contractConsumptionOverviewCtrl',
        resolve: {
            access: checkAccessFromMenu('contracts'),
        },
    }).state('userSearch', {
        parent: 'home',
        url: '/search/:search',
        templateUrl: '/states/userContractInfo/userContractInfo.html',
        reloadOnSearch: false,
        controller: 'userContractInfoCtrl',
        resolve: {
            access: checkAccessFromMenu('clients'),
        },
    }).state('userInfoOnContract', {
        parent: 'home',
        url: '/info/:customerId/:contractId',
        templateUrl: '/states/userContractInfo/userContractInfo.html',
        reloadOnSearch: false,
        controller: 'userContractInfoCtrl',
        resolve: {
            access: checkAccessFromMenu('clients'),
        },
    }).state('userContractInfo', {
        parent: 'home',
        url: '/user-contract-info/:customerId/:contractId',
        templateUrl: '/states/userContractInfo/userContractInfo.html',
        reloadOnSearch: false,
        controller: 'userContractInfoCtrl',
        resolve: {
            access: checkAccessFromMenu('clients'),
        },
    }).state('stats', {
        parent: 'home',
        url: '/stats',
        templateUrl: '/states/stats/stats.html',
        reloadOnSearch: false,
        controller: 'statsCtrl',
        resolve: {
            access: checkAccessFromMenu('stats'),
        },
    }).state('coordinator', {
        parent: 'home',
        url: '/suivi-marche',
        templateUrl: '/states/coordinator/coordinator.html',
        reloadOnSearch: false,
        controller: 'coordinatorCtrl',
        resolve: {
            access: checkAccessFromMenu('coordinator'),
        },
    }).state('navigation', {
        parent: 'home',
        url: '/navigation',
        templateUrl: '/states/navigation/navigation.html',
        reloadOnSearch: false,
        controller: 'navigationCtrl',
        resolve: {
            access: checkAccessFromMenu('navigation'),
        },
    }).state('navigationErrors', {
        parent: 'home',
        url: '/nav-errors',
        templateUrl: '/states/navigationErrors/navigationErrors.html',
        reloadOnSearch: false,
        controller: 'navigationErrorsCtrl',
        resolve: {
            access: checkAccessFromMenu('navigationErrors'),
        },
    }).state('activations', {
        parent: 'home',
        url: '/activations',
        templateUrl: '/states/activations/activations.html',
        reloadOnSearch: false,
        controller: 'activationsCtrl',
        resolve: {
            access: checkAccessFromMenu('activations'),
        },
    }).state('overdues', {
        parent: 'home',
        url: '/overdues',
        templateUrl: '/states/overdues/overdues.html',
        reloadOnSearch: false,
        controller: 'overduesCtrl',
        resolve: {
            access: checkAccessFromMenu('overdues'),
        },
    }).state('contracts', {
        parent: 'home',
        url: '/contracts?prm',
        templateUrl: '/states/contracts/contracts.html',
        reloadOnSearch: false,
        controller: 'contractsCtrl',
        resolve: {
            access: checkAccessFromMenu('contracts'),
        },
    }).state('contractsGas', {
        parent: 'home',
        url: '/contracts-gas?pce',
        templateUrl: '/states/contractsGas/contractsGas.html',
        reloadOnSearch: false,
        controller: 'contractsGasCtrl',
        resolve: {
            access: checkAccessFromMenu('contractsGas'),
        },
    }).state('pdls', {
        parent: 'home',
        url: '/pdls?prm&id_contract&category&brand&status&activate&initfunction',
        templateUrl: '/states/pdls/pdls.html',
        reloadOnSearch: false,
        controller: 'pdlsCtrl',
        resolve: {
            access: checkAccessFromMenu('pdls'),
        },
    }).state('pces', {
        parent: 'home',
        url: '/pces?pce&id_contract&category&brand&status',
        templateUrl: '/states/pces/pces.html',
        reloadOnSearch: false,
        controller: 'pcesCtrl',
        resolve: {
            access: checkAccessFromMenu('pces'),
        },
    }).state('newPdl', {
        parent: 'home',
        url: '/new-pdl?id_account',
        templateUrl: '/states/newPdl/newPdl.html',
        reloadOnSearch: false,
        controller: 'newPdlCtrl',
        resolve: {
            access: checkAccessFromMenu('newPdl'),
        },
    }).state('newPdl2', {
        parent: 'home',
        url: '/new-pdl2?id_account',
        templateUrl: '/states/newPdl2/newPdl2.html',
        reloadOnSearch: false,
        controller: 'newPdl2Ctrl',
        resolve: {
            access: checkAccessFromMenu('newPdl2'),
        },
    }).state('newPce', {
        parent: 'home',
        url: '/new-pce?id_account&id_draft',
        templateUrl: '/states/newPce/newPce.html',
        reloadOnSearch: false,
        controller: 'newPceCtrl',
        resolve: {
            access: checkAccessFromMenu('newPce'),
        },
    }).state('contractDrafts', {
        parent: 'home',
        url: '/contract-drafts?id',
        templateUrl: '/states/contractDrafts/contractDrafts.html',
        reloadOnSearch: false,
        controller: 'contractDraftsCtrl',
        resolve: {
            access: checkAccessFromMenu('contractDrafts'),
        },
    }).state('clients', {
        parent: 'home',
        url: '/clients?name&mail',
        templateUrl: '/states/clients/clients.html',
        reloadOnSearch: false,
        controller: 'clientsCtrl',
        resolve: {
            access: checkAccessFromMenu('clients'),
        },
    }).state('users', {
        parent: 'home',
        url: '/users',
        templateUrl: '/states/users/users.html',
        reloadOnSearch: false,
        controller: 'usersCtrl',
        resolve: {
            access: checkAccessFromMenu('users'),
            organizations(OrganizationService) {
                return OrganizationService.getOrgz()
            },
            groups(DataAccessReferences) {
                return DataAccessReferences.ref({ id: 'groups-filtered' }).$promise
            },
        },
    }).state('deals', {
        parent: 'home',
        url: '/affaires',
        templateUrl: '/states/deals/deals.html',
        reloadOnSearch: false,
        controller: 'dealsCtrl',
        resolve: {
            access: checkAccessFromMenu('deals'),
        },
    }).state('parsing', {
        parent: 'home',
        url: '/parsing?id&filename',
        templateUrl: '/states/parsing/parsing.html',
        reloadOnSearch: false,
        controller: 'parsingCtrl',
        resolve: {
            access: checkAccessFromMenu('parsing'),
        },
    }).state('enedisCalls', {
        parent: 'home',
        url: '/enedis-calls',
        templateUrl: '/states/enedisCalls/enedisCalls.html',
        reloadOnSearch: false,
        controller: 'enedisCallsCtrl',
        resolve: {
            access: checkAccessFromMenu('enedisCalls'),
        },
    }).state('sendInBlueMails', {
        parent: 'home',
        url: '/send-in-blue-mails',
        templateUrl: '/states/sendInBlueMails/sendInBlueMails.html',
        reloadOnSearch: false,
        controller: 'sendInBlueMailsCtrl',
        resolve: {
            access: checkAccessFromMenu('sendInBlueMails'),
        },
    }).state('processes', {
        parent: 'home',
        url: '/processes',
        templateUrl: '/states/processes/processes.html',
        reloadOnSearch: false,
        controller: 'processesCtrl',
        resolve: {
            access: checkAccessFromMenu('processes'),
        },
    }).state('features', {
        parent: 'home',
        url: '/features',
        templateUrl: '/states/features/features.html',
        reloadOnSearch: false,
        controller: 'featuresCtrl',
        resolve: {
            access: checkAccessFromMenu('features'),
        },
    }).state('tags', {
        parent: 'home',
        url: '/tags',
        templateUrl: '/states/tags/tags.html',
        reloadOnSearch: false,
        controller: 'tagsCtrl',
        resolve: {
            access: checkAccessFromMenu('tags'),
        },
    }).state('contractTags', {
        parent: 'home',
        url: '/contract-tags',
        templateUrl: '/states/contractTags/contractTags.html',
        reloadOnSearch: false,
        controller: 'contractTagsCtrl',
        resolve: {
            access: checkAccessFromMenu('contractTags'),
        },
    }).state('promos', {
        parent: 'home',
        url: '/promos',
        templateUrl: '/states/promos/promos.html',
        reloadOnSearch: false,
        controller: 'promosCtrl',
        resolve: {
            access: checkAccessFromMenu('promos'),
        },
    }).state('payments', {
        parent: 'home',
        url: '/payments?id',
        templateUrl: '/states/payments/payments.html',
        reloadOnSearch: false,
        controller: 'paymentsCtrl',
        resolve: {
            access: checkAccessFromMenu('payments'),
        },
    }).state('timetableList', {
        parent: 'home',
        url: '/timetable-list',
        templateUrl: '/states/timetableList/timetableList.html',
        reloadOnSearch: false,
        controller: 'timetableListCtrl',
        resolve: {
            access: checkAccessFromMenu('timetableList'),
        },
    }).state('warnings', {
        parent: 'home',
        url: '/warnings',
        templateUrl: '/states/warnings/warnings.html',
        reloadOnSearch: false,
        controller: 'warningsCtrl',
        resolve: {
            access: checkAccessFromMenu('warnings'),
        },
    }).state('simulation', {
        parent: 'home',
        url: '/simulation',
        templateUrl: '/states/simulation/simulation.html',
        reloadOnSearch: false,
        controller: 'simulationCtrl',
        resolve: {
            access: checkAccessFromMenu('simulation'),
        },
    }).state('salesTunnel', {
        parent: 'home',
        url: '/sales-tunnel?user',
        templateUrl: '/states/salesTunnelV2/salesTunnelV2.html',
        reloadOnSearch: false,
        controller: 'salesTunnelV2Ctrl',
        resolve: {
            access: checkAccessFromMenu('salesTunnel'),
        },
    }).state('salesTunnelV2', {
        parent: 'home',
        url: '/sales-tunnel-v2?user&draft',
        templateUrl: '/states/salesTunnelV2/salesTunnelV2.html',
        reloadOnSearch: false,
        controller: 'salesTunnelV2Ctrl',
        resolve: {
            access: checkAccessFromMenu('salesTunnelV2'),
        },
    }).state('salesTunnelV3', {
        parent: 'home',
        url: '/sales-tunnel-v3?user&draft',
        templateUrl: '/states/salesTunnelV3/salesTunnelV3.html',
        reloadOnSearch: false,
        controller: 'salesTunnelV3Ctrl',
        resolve: {
            access: checkAccessFromMenu('salesTunnelV3'),
            providerCalendar: (ReferencesService) => {
                return ReferencesService.getRef('ref-provider-calendar', true)
            },
        },
    }).state('salesTunnelGas', {
        parent: 'home',
        url: '/sales-tunnel-gas',
        templateUrl: '/states/salesTunnelGas/salesTunnelGas.html',
        reloadOnSearch: false,
        controller: 'salesTunnelGasCtrl',
        resolve: {
            access: checkAccessFromMenu('salesTunnelGas'),
        },
    }).state('offers', {
        parent: 'home',
        url: '/offers',
        templateUrl: '/states/offers/offers.html',
        reloadOnSearch: false,
        controller: 'offersCtrl',
        resolve: {
            access: checkAccessFromMenu('offers'),
            organizations(OrganizationService) {
                return OrganizationService.getOrgz()
            },
        },
    }).state('providerOffers', {
        parent: 'home',
        url: '/provider-offers',
        templateUrl: '/states/providerOffers/providerOffers.html',
        reloadOnSearch: false,
        controller: 'providerOffersCtrl',
        resolve: {
            access: checkAccessFromMenu('providerOffers'),
            organizations(OrganizationService) {
                return OrganizationService.getOrgz()
            },
        },
    }).state('variables', {
        parent: 'home',
        url: '/variables',
        templateUrl: '/states/variables/variables.html',
        reloadOnSearch: false,
        controller: 'variablesCtrl',
        resolve: {
            access: checkAccessFromMenu('variables'),
        },
    }).state('organizations', {
        parent: 'home',
        url: '/organizations',
        templateUrl: '/states/organizations/organizations.html',
        reloadOnSearch: false,
        controller: 'organizationsCtrl',
        resolve: {
            access: checkAccessFromMenu('organizations'),
        },
    }).state('turpe', {
        parent: 'home',
        url: '/turpe',
        templateUrl: '/states/turpe/turpe.html',
        reloadOnSearch: false,
        controller: 'turpeCtrl',
        resolve: {
            access: checkAccessFromMenu('turpe'),
        },
    }).state('trv', {
        parent: 'home',
        url: '/trv',
        templateUrl: '/states/trv/trv.html',
        reloadOnSearch: false,
        controller: 'trvCtrl',
        resolve: {
            access: checkAccessFromMenu('trv'),
        },
    }).state('tools', {
        parent: 'home',
        url: '/tools',
        templateUrl: '/states/tools/tools.html',
        reloadOnSearch: false,
        controller: 'toolsCtrl',
        resolve: {
            access: checkAccessFromMenu('tools'),
        },
    }).state('invoicesV2', {
        parent: 'home',
        url: '/invoices-v2?id&id_contract',
        templateUrl: '/states/invoicesV2/invoicesV2.html',
        reloadOnSearch: false,
        controller: 'invoicesV2Ctrl',
        resolve: {
            access: checkAccessFromMenu('invoicesV2'),
            b2g: () => false,
        },
    }).state('metaInvoicesB2G', {
        parent: 'home',
        url: '/meta-invoices-b2g?category&id&invoice_number',
        templateUrl: '/states/metaInvoicesB2G/metaInvoicesB2G.html',
        reloadOnSearch: false,
        controller: 'metaInvoicesB2GCtrl',
        resolve: {
            access: checkAccessFromMenu('metaInvoicesB2G'),
            clientMode: () => false,
        },
    }).state('metaInvoicesCutoff', {
        parent: 'home',
        url: '/meta-invoices-cutoff?month&year',
        templateUrl: '/states/metaInvoicesCutoff/metaInvoicesCutoff.html',
        reloadOnSearch: false,
        controller: 'metaInvoicesCutoffCtrl',
        resolve: {
            access: checkAccessFromMenu('metaInvoicesCutoff'),
        },
    }).state('metaInvoicesB2GPreliminary', {
        parent: 'home',
        url: '/pre-meta-invoices-b2g?category&id',
        templateUrl: '/states/metaInvoicesB2GPreliminary/metaInvoicesB2GPreliminary.html',
        reloadOnSearch: false,
        controller: 'metaInvoicesB2GPreliminaryCtrl',
        resolve: {
            access: checkAccessFromMenu('metaInvoicesB2GPreliminary'),
        },
    }).state('myMetaInvoicesB2G', {
        parent: 'home',
        url: '/mes-factures?category&id&invoice_number&total_paid',
        templateUrl: '/states/metaInvoicesB2G/metaInvoicesB2G.html',
        reloadOnSearch: false,
        controller: 'metaInvoicesB2GCtrl',
        resolve: {
            access: checkAccessFromMenu('myMetaInvoicesB2G'),
            clientMode: () => true,
        },
    }).state('invoicesB2G', {
        parent: 'home',
        url: '/invoices-b2g?id&id_contract',
        templateUrl: '/states/invoicesV2/invoicesV2.html',
        reloadOnSearch: false,
        controller: 'invoicesV2Ctrl',
        resolve: {
            access: checkAccessFromMenu('invoicesB2G'),
            b2g: () => true,
        },
    }).state('invoicesCutoff', {
        parent: 'home',
        url: '/invoices-cutoff?month&year&id',
        templateUrl: '/states/invoicesCutoff/invoicesCutoff.html',
        reloadOnSearch: false,
        controller: 'invoicesCutoffCtrl',
        resolve: {
            access: checkAccessFromMenu('invoicesCutoff'),
        },
    }).state('b2gBillingDashboard', {
        parent: 'home',
        url: '/b2g-billing-dashboard',
        templateUrl: '/states/b2gBillingDashboard/b2gBillingDashboard.html',
        reloadOnSearch: false,
        controller: 'b2gBillingDashboardCtrl',
        resolve: {
            access: checkAccessFromMenu('b2gBillingDashboard'),
        },
    }).state('readings', {
        parent: 'home',
        url: '/readings?id_prm',
        templateUrl: '/states/readings/readings.html',
        reloadOnSearch: false,
        controller: 'readingsCtrl',
        resolve: {
            access: checkAccessFromMenu('readings'),
        },
    }).state('readingsGas', {
        parent: 'home',
        url: '/readings-gas?id_pce',
        templateUrl: '/states/readingsGas/readingsGas.html',
        reloadOnSearch: false,
        controller: 'readingsGasCtrl',
        resolve: {
            access: checkAccessFromMenu('readingsGas'),
        },
    }).state('billingModalities', {
        parent: 'home',
        url: '/billing-modalities',
        templateUrl: '/states/billingModalities/billingModalities.html',
        reloadOnSearch: false,
        controller: 'billingModalitiesCtrl',
        resolve: {
            access: checkAccessFromMenu('billingModalities'),
        },
    }).state('directory', {
        parent: 'home',
        url: '/directory',
        templateUrl: '/states/directory/directory.html',
        reloadOnSearch: false,
        controller: 'directoryCtrl',
        resolve: {
            access: checkAccessFromMenu('directory'),
        },
    }).state('complaints', {
        parent: 'home',
        url: '/complaints?id_contract&key',
        templateUrl: '/states/complaints/complaints.html',
        reloadOnSearch: false,
        controller: 'complaintsCtrl',
        resolve: {
            access: checkAccessFromMenu('complaints'),
        },
    }).state('supervision', {
        parent: 'home',
        url: '/supervision',
        templateUrl: '/states/supervision/supervision.html',
        reloadOnSearch: false,
        controller: 'supervisionCtrl',
        resolve: {
            access: checkAccessFromMenu(['parsing', 'supervision']),
        },
    }).state('metrics', {
        parent: 'home',
        url: '/metrics',
        templateUrl: '/states/metrics/metrics.html',
        reloadOnSearch: false,
        controller: 'metricsCtrl',
        resolve: {
            access: checkAccessFromMenu('metrics'),
        },
    }).state('wiki', {
        parent: 'home',
        url: '/wiki?title',
        templateUrl: '/states/wiki/wiki.html',
        reloadOnSearch: false,
        controller: 'wikiCtrl',
        resolve: {
            checkWikiAccessFromMenu,
            content($stateParams, Confluence) {
                return Confluence.getContent({ title: $stateParams.title }).$promise
                .catch((error) => {
                    console.log('Erreur à la récupération du contenu confluence', error)
                    return { title: (error && error.status === 401) ? 'Non autorisé' : 'Contenu introuvable', results: [] }
                })
            },
        },
    }).state('swagger', {
        parent: 'home',
        url: '/swagger',
        templateUrl: '/states/swagger/swagger.html',
        reloadOnSearch: false,
        controller: 'swaggerCtrl',
        resolve: {
            access: checkAccessFromMenu('swagger'),
        },
    }).state('sge', {
        parent: 'home',
        url: '/sge/:search',
        templateUrl: '/states/sge/sge.html',
        reloadOnSearch: false,
        controller: 'sgeCtrl',
        params: {
            search: null,
        },
    }).state('rta', {
        parent: 'home',
        url: '/rta',
        templateUrl: '/states/rta/rta.html',
        reloadOnSearch: false,
        controller: 'rtaCtrl',
        resolve: {
            access: checkAccessFromMenu('rta'),
        },
    }).state('urgentCalls', {
        parent: 'home',
        url: '/urgentCalls',
        templateUrl: '/states/urgentCalls/urgentCalls.html',
        reloadOnSearch: false,
        controller: 'urgentCallsCtrl',
        resolve: {
            access: checkAccessFromMenu('urgentCalls'),
        },
    }).state('urgentCallsN1', {
        parent: 'home',
        url: '/urgentCallsN1',
        templateUrl: '/states/urgentCallsN1/urgentCallsN1.html',
        reloadOnSearch: false,
        controller: 'urgentCallsN1Ctrl',
        resolve: {
            access: checkAccessFromMenu('urgentCallsN1'),
        },
    }).state('cases', {
        parent: 'home',
        url: '/cases',
        templateUrl: '/states/cases/cases.html',
        reloadOnSearch: false,
        controller: 'casesCtrl',
        resolve: {
            access: checkAccessFromMenu('cases'),
            b2g: () => false,
        },
    }).state('casesB2G', {
        parent: 'home',
        url: '/cases-b2g',
        templateUrl: '/states/cases/cases.html',
        reloadOnSearch: false,
        controller: 'casesCtrl',
        resolve: {
            access: checkAccessFromMenu('casesB2G'),
            b2g: () => true,
        },
    }).state('nominations', {
        parent: 'home',
        url: '/nominations',
        templateUrl: '/states/nominations/nominations.html',
        reloadOnSearch: false,
        controller: 'nominationsCtrl',
        resolve: {
            access: checkAccessFromMenu('nominations'),
        },
    }).state('taxDeclaration', {
        parent: 'home',
        url: '/taxDeclaration',
        templateUrl: '/states/taxDeclaration/taxDeclaration.html',
        reloadOnSearch: false,
        controller: 'taxDeclarationCtrl',
        resolve: {
            access: checkAccessFromMenu('taxDeclaration'),
        },
    }).state('refBeneficiary', {
        parent: 'home',
        url: '/refBeneficiary',
        templateUrl: '/states/refBeneficiary/refBeneficiary.html',
        reloadOnSearch: false,
        controller: 'refBeneficiaryCtrl',
        resolve: {
            access: checkAccessFromMenu('refBeneficiary'),
        },
    }).state('categories', {
        parent: 'home',
        url: '/categories?brand&name&complete&action&siret&id&modal&customer_id',
        templateUrl: '/states/categories/categories.html',
        reloadOnSearch: false,
        controller: 'categoriesCtrl',
        resolve: {
            access: checkAccessFromMenu('categories'),
        },
    }).state('b2gHomeV2', {
        parent: 'home',
        url: '/b2g-home-v2',
        templateUrl: '/states/b2gHomeV2/b2gHomeV2.html',
        reloadOnSearch: false,
        controller: 'b2gHomeV2Ctrl',
        resolve: {
            access: checkAccessFromMenu('b2gHomeV2'),
            myAccounts(DataAccess) {
                return DataAccess.myAccounts({ light: true }).$promise
            },
        },
    }).state('csrB2gHome', {
        parent: 'home',
        url: '/csr-b2g-home?id_account',
        templateUrl: '/states/csrB2gHome/csrB2gHome.html',
        reloadOnSearch: false,
        controller: 'csrB2gHomeCtrl',
        resolve: {
            access: checkAccessFromMenu('csrB2gHome'),
        },
    }).state('zendeskB2g', {
        parent: 'home',
        url: '/b2g-jira?status',
        templateUrl: '/states/zendeskB2g/zendeskB2g.html',
        reloadOnSearch: false,
        controller: 'zendeskB2gCtrl',
        resolve: {
            access: checkAccessFromMenu('zendeskB2g'),
            myAccounts(DataAccess) {
                return DataAccess.myAccounts({ light: true }).$promise
            },
        },
    }).state('myAccountValidation', {
        parent: 'home',
        url: '/perimeter-validation?id_account',
        templateUrl: '/states/perimeterValidation/perimeterValidation.html',
        reloadOnSearch: false,
        controller: 'perimeterValidationCtrl',
        resolve: {
            access: checkAccessFromMenu('myAccountValidation'),
        },
    }).state('ogcContactLists', {
        parent: 'home',
        url: '/ogc-contact-lists',
        templateUrl: '/states/ogcContactLists/ogcContactLists.html',
        reloadOnSearch: false,
        controller: 'ogcContactListsCtrl',
        resolve: {
            access: checkAccessFromMenu('ogcContactLists'),
        },
    }).state('subscriptionLists', {
        parent: 'home',
        url: '/subscription-lists',
        templateUrl: '/states/subscriptionLists/subscriptionLists.html',
        reloadOnSearch: false,
        controller: 'subscriptionListsCtrl',
        resolve: {
            access: checkAccessFromMenu('subscriptionLists'),
        },
    }).state('cms', {
        parent: 'home',
        url: '/cms',
        templateUrl: '/states/cms/cms.html',
        reloadOnSearch: false,
        controller: 'cmsCtrl',
        resolve: {
            access: checkAccessFromMenu('cms'),
        },
    }).state('b2gBankDetails', {
        parent: 'home',
        url: '/b2g-bank-details?siret',
        templateUrl: '/states/b2gBankDetails/b2gBankDetails.html',
        reloadOnSearch: false,
        controller: 'b2gBankDetailsCtrl',
        resolve: {
            access: checkAccessFromMenu('b2gBankDetails'),
        },
    }).state('tinyUrls', {
        parent: 'home',
        url: '/tiny-urls',
        templateUrl: '/states/tinyUrls/tinyUrls.html',
        reloadOnSearch: false,
        controller: 'tinyUrlsCtrl',
        resolve: {
            access: checkAccessFromMenu('tinyUrls'),
        },
    }).state('temporaryConnections', {
        parent: 'home',
        url: '/temporary-connections?id',
        templateUrl: '/states/temporaryConnections/temporaryConnections.html',
        reloadOnSearch: false,
        controller: 'temporaryConnectionsCtrl',
        resolve: {
            access: checkAccessFromMenu('temporaryConnections'),
        },
    }).state('serviceOrders', {
        parent: 'home',
        url: '/service-orders',
        templateUrl: '/states/serviceOrders/serviceOrders.html',
        reloadOnSearch: false,
        controller: 'serviceOrdersCtrl',
        resolve: {
            access: checkAccessFromMenu('serviceOrders'),
        },
    }).state('dashboard', {
        parent: 'home',
        url: '/dashboard/:id',
        templateUrl: '/states/dashboard/dashboard.html',
        reloadOnSearch: false,
        controller: 'dashboardCtrl',
        resolve: {
            checkDashboardAccessFromMenu,
        },
    }).state('managedAccounts', {
        parent: 'home',
        url: '/managed-accounts?id&brand',
        templateUrl: '/states/managedAccounts/managedAccounts.html',
        reloadOnSearch: false,
        controller: 'managedAccountsCtrl',
        resolve: {
            access: checkAccessFromMenu('managedAccounts'),
        },
    }).state('optimizationValidation', {
        parent: 'home',
        url: '/optimization-validation?id_account',
        templateUrl: '/states/optimizationValidation/optimizationValidation.html',
        reloadOnSearch: false,
        controller: 'optimizationValidationCtrl',
        resolve: {
            access: checkAccessFromMenu('optimizationValidation'),
        },
    }).state('ecoSession', {
        parent: 'home',
        url: '/ecoSession?id_account',
        templateUrl: '/states/ecoSession/ecoSession.html',
        reloadOnSearch: false,
        controller: 'ecoSessionCtrl',
        resolve: {
            access: checkAccessFromMenu('ecoSession'),
        }
    }).state('managementSheets', {
        parent: 'home',
        url: '/management-sheets',
        templateUrl: '/states/managementSheets/managementSheets.html',
        reloadOnSearch: false,
        controller: 'managementSheetsCtrl',
        resolve: {
            access: checkAccessFromMenu('managementSheets'),
        },
    }).state('consumptionDriftReports', {
        parent: 'home',
        url: '/consumption-drift-reports',
        templateUrl: '/states/consumptionDriftReports/consumptionDriftReports.html',
        reloadOnSearch: false,
        controller: 'consumptionDriftReportsCtrl',
        resolve: {
            access: checkAccessFromMenu('consumptionDriftReports'),
        },
    }).state('m023', {
        parent: 'home',
        url: '/m023-request',
        templateUrl: '/states/m023/m023Request.html',
        reloadOnSearch: false,
        controller: 'm023RequestCtrl',
        resolve: {
            access: checkAccessFromMenu('m023'),
        },
    }).state('irrecoverabilityCertificates', {
        parent: 'home',
        url: '/irrecoverability-certificates',
        templateUrl: '/states/irrecoverabilityCertificates/irrecoverabilityCertificates.html',
        reloadOnSearch: false,
        controller: 'irrecoverabilityCertificatesCtrl',
        resolve: {
            access: checkAccessFromMenu('irrecoverabilityCertificates'),
        },
    }).state('irrecoverabilityDeclaration', {
        parent: 'home',
        url: '/irrecoverability-declaration',
        templateUrl: '/states/irrecoverabilityDeclaration/irrecoverabilityDeclaration.html',
        reloadOnSearch: false,
        controller: 'irrecoverabilityDeclarationCtrl',
        resolve: {
            access: checkAccessFromMenu('irrecoverabilityDeclaration'),
        },
    }).state('refConsents', {
        parent: 'home',
        url: '/ref-consents',
        templateUrl: '/states/refConsents/refConsents.html',
        reloadOnSearch: false,
        controller: 'refConsentsCtrl',
        resolve: {
            access: checkAccessFromMenu('refConsents'),
        },
    }).state('sirets', {
        parent: 'home',
        url: '/sirets?id',
        templateUrl: '/states/sirets/sirets.html',
        reloadOnSearch: false,
        controller: 'siretsCtrl',
        resolve: {
            access: checkAccessFromMenu('sirets'),
        },
    }).state('unknownPhoneNumber', {
        parent: 'home',
        url: '/unknown-phone-number',
        templateUrl: '/states/unknownPhoneNumber/unknownPhoneNumber.html',
        reloadOnSearch: false,
        controller: () => {},
    })

    const getHome = ($injector) => {
        const authService = $injector.get('AuthService')
        const role = Roles[authService.getAuth().groups]
        return role ? role.home : '/info/'
    }

    $urlRouterProvider.otherwise(($injector) => getHome($injector))

    return $locationProvider.html5Mode(true)
})
